import { deepClone, putDoormanTextTitle } from '@/helpers/utils';

export const okNokFields = ['textDateOk', 'textDateNok', 'otherDescriptionOk', 'otherDescriptionNok', 'additionalInformationOk',
  'additionalInformationNok'];

export const mapVehiclesTranslatableProperties = (field, label, value, uuid, translationLang) => {
  const isFieldToUpdate = okNokFields.includes(label) || label === 'codeRuleComment' ? field.uuid === uuid : field.code === label;

  return isFieldToUpdate
    ? {
      ...field,
      translations: {
        ...field.translations,
        [translationLang]: value,
      },
    }
    : field;
};

export const mapVehiclesTranslatablePropertiesByPlant = (label, plantsTranslations, plantSelected, value, uuidField, translationLang) => {
  if (plantsTranslations.plant.wkzNumber === plantSelected.wkzNumber) {
    if (okNokFields.includes(label)) {
      const groupFoundedIndex = plantsTranslations?.translatablePropertiesByGroup
        ?.findIndex(({ translatableProperties }) => translatableProperties?.find(({ uuid }) => uuid === uuidField));

      plantsTranslations.translatablePropertiesByGroup[groupFoundedIndex].translatableProperties = plantsTranslations?.translatablePropertiesByGroup?.[groupFoundedIndex]?.translatableProperties
        .map((field) => mapVehiclesTranslatableProperties(field, label, value, uuidField, translationLang));

      return plantsTranslations;
    }

    return {
      ...plantsTranslations,
      translatableProperties: plantsTranslations.translatableProperties
        .map((field) => mapVehiclesTranslatableProperties(field, label, value, uuidField, translationLang)),
    };
  }

  return plantsTranslations;
};

export const proccessCampaignTrans = (campaignTrans, campaign) => {
  if (!campaignTrans || !campaign) return campaignTrans;
  const isDoorman = campaign?.info?.doormanSelected;

  if (isDoorman) {
    const newValues = deepClone(campaignTrans);
    newValues.translatableProperties.campaignTitle.translations.DE = putDoormanTextTitle(newValues.translatableProperties.campaignTitle.translations.DE, 'de', true);
    newValues.translatableProperties.campaignTitle.translations.EN = putDoormanTextTitle(newValues.translatableProperties.campaignTitle.translations.EN, 'en', true);
    campaign.info.title.DE = newValues.translatableProperties.campaignTitle.translations.DE;
    campaign.info.title.EN = newValues.translatableProperties.campaignTitle.translations.EN;

    return newValues;
  }

  return campaignTrans;
};
